import React from 'react';

// GLOBAL VARIABLES
import { INTERFACE, RECORD, SETTINGS } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions.js';

// ROUTER COMPONENTS
import { Navigate, Route, Routes } from "react-router-dom";

// ROUTES
import EmailSettingList from './emailSettings/List';
import EmailSettingUpdate from './emailSettings/Update';

// MAIN COMPONENT
const EmailSettings = () => (
  <Routes>
    <Route
      path="/"
      element={<EmailSettingList />}
    />
    <Route
      path={makePath(RECORD.edit, ':recordID')}
      element={<EmailSettingUpdate />}
    />
    <Route path="*" element={<Navigate to={makePath(INTERFACE.settings, SETTINGS.emailSettings)} replace />} />
  </Routes>
)

// EXPORT
export default EmailSettings;
